var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86612 4.86612C5.10054 4.6317 5.41848 4.5 5.75 4.5H15C15.4142 4.5 15.75 4.16421 15.75 3.75C15.75 3.33579 15.4142 3 15 3H5.75C5.02065 3 4.32118 3.28973 3.80546 3.80546C3.28973 4.32118 3 5.02065 3 5.75V18.25C3 18.9793 3.28973 19.6788 3.80546 20.1945C4.32118 20.7103 5.02065 21 5.75 21H18.25C18.9793 21 19.6788 20.7103 20.1945 20.1945C20.7103 19.6788 21 18.9793 21 18.25V13.5C21 13.0858 20.6642 12.75 20.25 12.75C19.8358 12.75 19.5 13.0858 19.5 13.5V18.25C19.5 18.5815 19.3683 18.8995 19.1339 19.1339C18.8995 19.3683 18.5815 19.5 18.25 19.5H5.75C5.41848 19.5 5.10054 19.3683 4.86612 19.1339C4.6317 18.8995 4.5 18.5815 4.5 18.25V5.75C4.5 5.41848 4.6317 5.10054 4.86612 4.86612ZM22.2803 5.78033C22.5732 5.48744 22.5732 5.01256 22.2803 4.71967C21.9874 4.42678 21.5125 4.42678 21.2196 4.71967L12 13.9393L9.53033 11.4697C9.23744 11.1768 8.76256 11.1768 8.46967 11.4697C8.17678 11.7626 8.17678 12.2374 8.46967 12.5303L11.4697 15.5303C11.6103 15.671 11.8011 15.75 12 15.75C12.1989 15.75 12.3897 15.671 12.5303 15.5303L22.2803 5.78033Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare);
export default __webpack_public_path__ + "static/media/check-square.329c2ec2a7d574021a2e3a412413ae46.svg";
export { ForwardRef as ReactComponent };